var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandMore = function SvgExpandMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.825 7.426 10 11.243 6.175 7.426 5 8.601l5 5 5-5z"
  })));
};
export { SvgExpandMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImV4cGFuZF9tb3JlIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEzLjgyNSA3LjQyNjI3TDEwIDExLjI0MjlMNi4xNzUgNy40MjYyN0w1IDguNjAxMjdMMTAgMTMuNjAxM0wxNSA4LjYwMTI3TDEzLjgyNSA3LjQyNjI3WiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8L3N2Zz4K";